import { render, staticRenderFns } from "./batchReceipt.vue?vue&type=template&id=4f3cd58b&"
import script from "./batchReceipt.vue?vue&type=script&lang=js&"
export * from "./batchReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports